import { render, staticRenderFns } from "./CreateRewardModal.vue?vue&type=template&id=9dcdfdbc&scoped=true&"
import script from "./CreateRewardModal.vue?vue&type=script&lang=ts&"
export * from "./CreateRewardModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRewardModal.vue?vue&type=style&index=0&id=9dcdfdbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcdfdbc",
  null
  
)

export default component.exports